/** Every in-app path, built in one place so links never drift from the router. */
export const paths = {
  home: '/',
  needsYou: '/#needs-you',
  intake: '/intake',
  clients: (filter?: string) =>
    filter && filter !== 'all' ? `/clients?filter=${filter}` : '/clients',
  client: (id: string, wide = false) => `/clients/${id}${wide ? '?wide=true' : ''}`,
  year: (clientId: string, y: number, type?: string | null) =>
    `/clients/${clientId}/years/${y}${type ? `?type=${type}` : ''}`,
  deliverable: (id: string, v?: number) => `/deliverables/${id}${v ? `?v=${v}` : ''}`,
  conversation: (id: string) => `/conversations/${id}`,
  /** a conversation that exists only once its first message is sent */
  newConversation: '/conversations/new',
  usage: '/usage',
  settings: '/settings',
  states: '/states',
  signIn: '/sign-in',
  setup: '/setup',
};
